import React from 'react';
import styled from 'styled-components';
import Reveal from '../components/Reveal';
import { siteConfig } from '../siteConfig';

const Section = styled.section`
  padding: ${({ theme }) => theme.spacing.section} ${({ theme }) => theme.container.gutter};
`;

const Inner = styled.div`
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: clamp(32px, 5vw, 80px);
  align-items: start;
  max-width: ${({ theme }) => theme.container.maxWidth};
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const Kicker = styled.div`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 0.76rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.accent};
  margin-bottom: 18px;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4.4vw, 3.7rem);
  line-height: 1.02;
  letter-spacing: -0.025em;
  font-weight: 700;
`;

const Body = styled(Reveal)`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const Standfirst = styled.p`
  font-size: clamp(1.1rem, 1.5vw, 1.4rem);
  line-height: 1.5;
`;

const Copy = styled.p`
  font-size: 1.05rem;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.muted};
`;

const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: clamp(28px, 4vw, 64px);
  margin-top: 6px;
`;

const MetaItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const MetaLabel = styled.div`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 0.74rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.accent};
`;

const MetaValue = styled.div`
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.95rem;
  line-height: 1.5;
`;

const About: React.FC = () => (
  <Section id="about">
    <Inner>
      <Reveal>
        <Kicker>03 / Who we are</Kicker>
        <Title>
          A consultancy that <em>ships</em>.
        </Title>
      </Reveal>

      <Body delay={120}>
        <Standfirst>
          Proteus Technologies is a technology consultancy specialising in robust, scalable software
          for businesses across a range of sectors — with particular expertise in Shipbroking, Legal,
          Media, and startup environments.
        </Standfirst>
        <Copy>
          We focus on correctness, reliability and business outcomes: custom software,
          well‑documented APIs, modern DevOps, and the option for us to build, staff and run whole
          projects end‑to‑end. We can also train and mentor your team so the capability stays
          in‑house.
        </Copy>
        <Meta>
          <MetaItem>
            <MetaLabel>Location</MetaLabel>
            <MetaValue>{siteConfig.location}</MetaValue>
          </MetaItem>
          <MetaItem>
            <MetaLabel>Registered</MetaLabel>
            <MetaValue>
              {siteConfig.companyName}
              <br />
              Company No. {siteConfig.companyNumber} (England &amp; Wales)
            </MetaValue>
          </MetaItem>
        </Meta>
      </Body>
    </Inner>
  </Section>
);

export default About;
